import { Component, Input } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { OrderComponent } from 'components/sale/order.component';
import { ClosedSalesflowComponent } from 'components/task/salesflow/closed-salesflow.component';
import { ViewSalesflowComponent } from 'components/task/salesflow/view-salesflow.component';
import { TaskflowTemplateTagConstants } from 'constants/TaskflowTemplateTagConstants';
import { TaskflowModel } from 'models/generated/Entities.GormCrm.Taskflow';
import { Layout } from 'modules/layout';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { TaskService } from 'services/task.service';
import { DefaultTaskflowComponent } from './default-taskflow.component';

@Component({
	selector: 'view-taskflow',
	templateUrl: './view-taskflow.component.html',
	imports: [Layout, ViewSalesflowComponent, ClosedSalesflowComponent, DefaultTaskflowComponent]
})
@ComponentUrl('taskflow')
export class ViewTaskflowComponent {
	public taskflow?: TaskflowModel;
	public taskflowViewType = TaskflowViewType;
	public currentTaskflowViewType = TaskflowViewType.Default;

	@UrlParam @Input() 
	set taskflowId(id: string) {
		if (!id) return;
		this._requestedTaskflowId = id;
		this.taskflow = undefined;
		this.taskService.getTaskflow(id)
			.then(taskflow => {
				this.taskflow = taskflow;
				const incompleteTaskActions = taskflow.taskActions.filter(taskAction =>
						taskAction.completed == null && !this.taskService.isTriggerTask(taskAction))
					.sort((a, b) => { return a.step - b.step });
				if (this.selectedActionId == undefined) {
					if (incompleteTaskActions.length > 0) {
						this.selectedActionId = incompleteTaskActions[0].id;
					} else if (taskflow.taskActions.length > 0) {
						let nonTriggerTaskAction = taskflow.taskActions.find(ta => !this.taskService.isTriggerTask(ta));
						if (nonTriggerTaskAction) this.selectedActionId = nonTriggerTaskAction.id;
					}
				}
				this.setTaskflowViewType();
				if (this.currentTaskflowViewType !== TaskflowViewType.Navigation)
					this.navigate.openNavigationView(this, 'company-related-views', ViewCompanyComponent).then(viewCompany => { viewCompany.companyId = this.taskflow?.companyId!; });
			});
	}
	get taskflowId() {
		return this.taskflow ? this.taskflow.id! : this._requestedTaskflowId;
	}
	@UrlParam @Input() selectedActionId?: string;

	private _requestedTaskflowId = '';

	constructor(private readonly taskService: TaskService, private readonly navigate: NavigationService) {
	}

	taskflowContainOpenTasks() {
		return this.taskflow && this.taskflow.taskActions.some(ta => ta.completed == null);
	}
	
	async setTaskflowViewType() {
		if (this.taskflow && this.taskflow.sourceTemplate) {
			const sourceTags = this.taskflow.sourceTemplate.taskflowTemplateTags.map(tft => tft.tag.toLowerCase())

			if (sourceTags.includes('salesflow')) {
				this.currentTaskflowViewType = TaskflowViewType.Salesflow;
			}
			if (sourceTags.includes(TaskflowTemplateTagConstants.orderWarning)) {
				this.currentTaskflowViewType = TaskflowViewType.Navigation;
				const orderId = await this.taskService.getOrderIdFromTaskflow(this.taskflowId);
				this.navigate.navigateView(this, OrderComponent).then(view => {
					view.orderId = orderId;
				});
			}
		}
	}
}

enum TaskflowViewType {
	Default,
	Salesflow,
	Navigation
}
